import { defineComponent as d, computed as s, useId as p, createBlock as f, openBlock as v, unref as e, withCtx as r, createTextVNode as _, toDisplayString as g, createVNode as x, mergeProps as b } from "vue";
import { RevTooltip as h } from "@ds/components/Tooltip";
import w from "../../../icons/generated/IconInfo.vue2.js";
import { tw as C } from "../../../utils/tailwind.js";
const z = /* @__PURE__ */ d({
  name: "RevHint",
  __name: "Hint",
  props: {
    content: {}
  },
  setup(a) {
    const c = a, i = s(() => c.content.length > 200), u = s(() => i.value ? C`sm:w-240 sm:max-w-240` : ""), o = p();
    return (m, F) => (v(), f(e(h), {
      id: e(o),
      "aria-hidden": "",
      class: "z-10",
      "content-class-names": u.value
    }, {
      trigger: r(({ show: t, hide: n, ...l }) => [
        x(e(w), b({
          "aria-describedby": e(o),
          class: "text-action-default-low",
          size: "16"
        }, l, {
          onFocusin: t,
          onFocusout: n,
          onMouseleave: n,
          onMouseover: t
        }), null, 16, ["aria-describedby", "onFocusin", "onFocusout", "onMouseleave", "onMouseover"])
      ]),
      default: r(() => [
        _(" " + g(m.content), 1)
      ]),
      _: 1
    }, 8, ["id", "content-class-names"]));
  }
});
export {
  z as default
};
